export function RecoveryCodeIcon(props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.39844 7.19981C2.39844 5.87432 3.47295 4.7998 4.79844 4.7998H10.7984L13.1984 7.1998H19.1984C20.5239 7.1998 21.5984 8.27432 21.5984 9.5998V16.7998C21.5984 18.1253 20.5239 19.1998 19.1984 19.1998H4.79844C3.47295 19.1998 2.39844 18.1253 2.39844 16.7998V7.19981ZM8.39844 11.9998H5.99844V14.3998H8.39844V11.9998ZM15.5984 11.9998H17.9984V14.3998H15.5984V11.9998ZM13.1984 11.9998H10.7984V14.3998H13.1984V11.9998Z"
        fill="currentColor"
      />
    </svg>
  );
}
